var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinnkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4651 17.5656H25.7384V21.1885C26.7861 19.1048 29.4729 17.2327 33.509 17.2327C41.2464 17.2327 43.0833 21.3804 43.0833 28.9905V43.0846H35.25V30.7236C35.25 26.3898 34.2023 23.9458 31.535 23.9458C27.8357 23.9458 26.2984 26.5798 26.2984 30.7217V43.0846H18.4651V17.5656ZM5.03291 42.7517H12.8662V17.2327H5.03291V42.7517ZM13.9884 8.91172C13.9887 9.5683 13.8584 10.2184 13.6053 10.8242C13.3521 11.43 12.9811 11.9795 12.5137 12.4406C11.5667 13.3819 10.2848 13.9087 8.94957 13.9055C7.61671 13.9046 6.33777 13.3791 5.38932 12.4426C4.92365 11.9799 4.55387 11.4298 4.30116 10.8239C4.04846 10.218 3.91779 9.5682 3.91666 8.91172C3.91666 7.58593 4.44541 6.31693 5.39128 5.38084C6.33889 4.44311 7.61838 3.91738 8.95153 3.91797C10.2871 3.91797 11.5679 4.44476 12.5137 5.38084C13.4577 6.31693 13.9884 7.58593 13.9884 8.91172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinnkedIn);
export default __webpack_public_path__ + "static/media/LinnkedIn.f12b6ffb846f5bfd6a424f7730ef4c95.svg";
export { ForwardRef as ReactComponent };